module.exports = __webpack_public_path__ + "img/behold-the-sonic-universe.5260955a.png";